<app-fifty-fathoms-character [seed]="seed + '-1'"></app-fifty-fathoms-character>
<app-fifty-fathoms-character [seed]="seed + '-2'"></app-fifty-fathoms-character>
<app-fifty-fathoms-character [seed]="seed + '-3'"></app-fifty-fathoms-character>
<app-fifty-fathoms-character [seed]="seed + '-4'"></app-fifty-fathoms-character>
